import React from "react";
import {Svg, G, Path, Rect} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";
import {Colors} from "./HSL_COLORS";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 35 35"
      version="1.1"
      preserveAspectRatio="xMidYMid meet">
      <G>
        <Rect fill={fill.inner} x="3" y="3" width="30" height="30" />
        <Path
          fill={fill.outer}
          d="M0.00109375,4.3334375 C0.00109375,1.9709375 1.96984375,0.0021875 4.33234375,0.0021875 L30.5801563,0.0021875 C33.0301563,0.0021875 34.9989063,1.9709375 34.9989063,4.3334375 L34.9989063,30.58125 C34.9989063,33.03125 33.0301563,35 30.5801563,35 L4.33234375,35 C1.96984375,35 0.00109375,33.03125 0.00109375,30.58125 L0.00109375,4.3334375 Z M5.29484375,29.575 C4.85734375,29.575 4.46359375,29.925 4.46359375,30.40625 C4.46359375,30.8875 4.85734375,31.2375 5.29484375,31.2375 L29.7051563,31.2375 C30.1864063,31.2375 30.5801563,30.8875 30.5801563,30.40625 C30.5801563,29.925 30.1864063,29.575 29.7051563,29.575 L5.29484375,29.575 Z M28.0426563,19.9073437 C28.0426563,19.9073437 24.5426563,18.9885937 22.1801562,18.4635937 C20.1239063,18.0260938 17.5864062,17.7198437 17.4114063,17.7198437 C17.2364063,17.7198437 14.7426563,18.0260938 12.6426563,18.4635937 C10.2801563,18.9885937 6.78015625,19.9073437 6.78015625,19.9073437 L7.74265625,28.21875 L27.1217188,28.21875 L28.0404688,19.9073437 L28.0426563,19.9073437 Z M12.64375,16.8010938 C14.74375,16.3635937 17.28125,16.0573438 17.4125,16.0135938 C17.54375,16.0573437 20.08125,16.3635937 22.18125,16.8010938 C23.8,17.1510938 24.71875,17.3698438 25.9,17.6760938 L25.9,11.5948438 C25.9,10.8073438 26.11875,9.75734375 24.0625,9.75734375 L20.25625,9.75734375 L20.25625,4.02609375 C20.25625,3.71984375 19.99375,3.45734375 19.6875,3.41359375 L15.1375,3.41359375 C14.83125,3.45734375 14.6125,3.71984375 14.56875,4.02609375 L14.56875,9.75625 L10.7625,9.75625 C8.70625,9.75625 8.925,10.80625 8.925,11.59375 L8.925,17.675 L12.64375,16.8 L12.64375,16.8010938 Z M14.7,12.9521875 C14.7,13.8709375 14,14.5709375 13.08125,14.5709375 C12.1625,14.5709375 11.4625,13.8709375 11.4625,12.9521875 C11.4625,12.0334375 12.1625,11.3334375 13.08125,11.3334375 C14,11.3334375 14.7,12.0334375 14.7,12.9521875 Z M19.03125,12.9521875 C19.03125,13.8709375 18.33125,14.5709375 17.4125,14.5709375 C16.5375,14.5709375 15.79375,13.8709375 15.79375,12.9521875 C15.79375,12.0334375 16.5375,11.3334375 17.4125,11.3334375 C18.33125,11.3334375 19.03125,12.0334375 19.03125,12.9521875 Z M23.3614063,12.9521875 C23.3614063,13.8709375 22.6614062,14.5709375 21.7426562,14.5709375 C20.8676562,14.5709375 20.1239062,13.8709375 20.1239062,12.9521875 C20.1239062,12.0334375 20.8676562,11.3334375 21.7426562,11.3334375 C22.6614062,11.3334375 23.3614063,12.0334375 23.3614063,12.9521875 Z"
          id="Ferry-1"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.shape({
    inner: PropTypes.string,
    outer: PropTypes.string,
  }),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.defaultProps = {
  fill: {
    inner: Colors.primary.hslWhite,
    outer: Colors.transport.ferry,
  },
};

Icon.displayName = "Icons.FerryRectangle";
